module.exports = __webpack_public_path__ + "img/dundee-council.7ea80f43.png";